(() => {
  const isImage = (target) => target instanceof Element && target.closest('img');
  document.addEventListener('contextmenu', (event) => {
    if (isImage(event.target)) event.preventDefault();
  }, true);
  document.addEventListener('dragstart', (event) => {
    if (isImage(event.target)) event.preventDefault();
  }, true);
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('.product__modal-opener--image')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  const protectImages = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root instanceof HTMLImageElement) root.draggable = false;
    root.querySelectorAll('img').forEach((image) => { image.draggable = false; });
  };
  protectImages(document);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(protectImages));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
